import React, { HTMLAttributes, useEffect, useMemo, useState } from 'react';
import { Select } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import LabelAction from '@/components/label-action';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import './index.less';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    width: number;
    height: number;
    lock?: boolean;
    onSizeRatio?: (value: number) => void;
}

const OPTIONS = [
    {
        label: '60%',
        value: 60,
    },
    {
        label: '65%',
        value: 65,
    },
    {
        label: '70%',
        value: 70,
    },
    {
        label: '75%',
        value: 75,
    },
    {
        label: '80%',
        value: 80,
    },
    {
        label: '85%',
        value: 85,
    },
    // {
    //     label: '自定义',
    //     value: -1,
    // },
];

function getRatio(stageWidth: number, stageHeight: number, width: number, height: number) {
    const stageRatio = stageWidth / stageHeight;
    const imageRatio = width / height;
    if (stageRatio <= imageRatio) {
        return Math.round((width / stageWidth) * 100);
    } else {
        return Math.round((height / stageHeight) * 100);
    }
}

const SizeRatioInspector: React.FC<IProps> = ({ id, width, height, lock, onSizeRatio }) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    const [currentSize, setCurrentSize] = useState(editor.stage.getActiveSize());
    const { width: stageWidth, height: stageHeight } = currentSize;
    const ratio = getRatio(stageWidth, stageHeight, width, height);

    useEffect(() => {
        const handleResize = editor.stage.onResize(() => {
            setCurrentSize(editor.stage.getActiveSize());
        });

        return () => {
            editor.off(handleResize);
        };
    }, []);

    useEffect(() => {
        setSizeRatio(ratio);
    }, [ratio]);

    const [sizeRatio, setSizeRatio] = useState<number>(ratio);

    const selectValue = useMemo(() => {
        if (OPTIONS.every((item) => item.value !== sizeRatio)) {
            // const lastOption = OPTIONS[OPTIONS.length - 1];
            // lastOption.label = `${sizeRatio}%`;
            // return -1;
            return `${sizeRatio}%`;
        }
        return sizeRatio;
    }, [sizeRatio]);

    const handleSize = (val: number) => {
        const size = { width: width * ((val - ratio) / ratio + 1), height: height * ((val - ratio) / ratio + 1) };
        editor.layer.modifyBasicProperties.size(id, { ...size, isRatio: true }, { writeHistory: true, isStart: false });
        setSizeRatio(val);
        onSizeRatio?.(val);
    };

    return (
        <div className="c-base-toolbar-controller c-base-toolbar-controller-vertical">
            <div className="size-ratio-select">
                <LabelAction title={$t((v) => v.baseToolbar.sizeRange)} align>
                    <Select
                        value={selectValue as number}
                        onChange={(val: number) => {
                            handleSize(val);
                        }}
                        dropdownMatchSelectWidth={false}
                        placement="bottomRight"
                        suffixIcon={<IconFont name="ChevronDownBlack" fontSize={10} />}
                    >
                        {OPTIONS.map((item) => (
                            <Select.Option key={item.value} value={item.value}>
                                {item.label || item.value + '%'}
                            </Select.Option>
                        ))}
                    </Select>
                </LabelAction>
            </div>
        </div>
    );
};
export default React.memo(SizeRatioInspector);
